import { useEffect, useRef, useState } from 'react'
import { useInView } from 'framer-motion'

export default function Counter({ end, duration = 2, suffix = '', prefix = '' }) {
  const [count, setCount] = useState(0)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-50px' })

  // Parse numeric target
  const targetNumber = parseInt(String(end).replace(/[^0-9]/g, ''), 10) || 0

  useEffect(() => {
    if (!isInView) return

    let start = 0
    const stepTime = 16 // ~60fps
    const totalSteps = (duration * 1000) / stepTime
    const increment = targetNumber / totalSteps

    const timer = setInterval(() => {
      start += increment
      if (start >= targetNumber) {
        setCount(targetNumber)
        clearInterval(timer)
      } else {
        setCount(Math.floor(start))
      }
    }, stepTime)

    return () => clearInterval(timer)
  }, [isInView, targetNumber, duration])

  return (
    <span ref={ref} className="tabular-nums">
      {prefix}
      {count.toLocaleString()}
      {suffix}
    </span>
  )
}
